import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController, AlertController, ModalController } from '@ionic/angular';
import { ProfileModalPage } from '../profile-modal/profile-modal.page';
import { employeeMenu, patientMenu, scientistMenu } from '../../interfaces/menus';

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss']
})
export class MobileMenuComponent implements OnInit {
  @Input() appPages: any[] = [];
  @Input() isDarkmode: boolean = false;
  
  public openDropdowns: { [key: string]: boolean } = {};
  public showSettings = false;

  constructor(
    private router: Router,
    private menuController: MenuController,
    private alertController: AlertController,
    private modalController: ModalController
  ) {}

  ngOnInit() {
    // Load menu pages if not provided
    if (!this.appPages || this.appPages.length === 0) {
      try {
        const storedMenu = localStorage.getItem('appMenu');
        if (storedMenu) {
          this.appPages = JSON.parse(storedMenu);
        }
      } catch (e) {
        console.error('Error loading menu:', e);
      }
    }
  }

  toggleDropdown(pageTitle: string) {
    this.openDropdowns[pageTitle] = !this.openDropdowns[pageTitle];
  }

  isDropdownOpen(pageTitle: string): boolean {
    return this.openDropdowns[pageTitle] || false;
  }

  closeMenu() {
    this.menuController.close('mobile-menu');
  }

  async selectProfile() {
    await this.profilePopup(true);
    this.showSettings = false;
  }

  async editMenu() {
    await this.customizeMenu(0, false);
    this.showSettings = false;
  }

  toggleSettings() {
    this.showSettings = !this.showSettings;
  }

  closeSettings() {
    this.showSettings = false;
  }

  async profilePopup(allowDismiss = false) {
    const alert = await this.alertController.create({
      header: 'Please choose a profile:',
      subHeader: 'Here you can select a predefined profile for the side menu. If you press "Custom View" then you can create your own profile. The profile can be changed at any time.',
      backdropDismiss: allowDismiss,
      buttons: [
        {
          text: 'Employee',
          handler: () => {
            localStorage.setItem('appMenu', JSON.stringify(employeeMenu));
            window.location.reload();
          }
        },
        {
          text: 'Scientist',
          handler: () => {
            localStorage.setItem('appMenu', JSON.stringify(scientistMenu));
            window.location.reload();
          }
        },
        {
          text: 'Patient',
          handler: () => {
            localStorage.setItem('appMenu', JSON.stringify(patientMenu));
            window.location.reload();
          }
        },
        {
          text: 'Custom View',
          handler: () => {
            this.customizeMenu();
          }
        }
      ]
    });
    await alert.present();
  }

  async customizeMenu(profile = 0, showBack = true) {
    const modal = await this.modalController.create({
      backdropDismiss: false,
      component: ProfileModalPage,
      componentProps: {
        profile: profile,
        showBack: showBack
      }
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data && data.change) {
      if (data.menu != null) {
        this.appPages = data.menu;
        localStorage.setItem('appMenu', JSON.stringify(data.menu));
      } else {
        this.profilePopup();
      }
    }
  }

  toggleDarkMode(event: any) {
    if (event.detail.checked) {
      document.body.setAttribute('data-theme', 'dark');
      localStorage.setItem('darkMode', JSON.stringify(true));
    } else {
      document.body.setAttribute('data-theme', 'light');
      localStorage.setItem('darkMode', JSON.stringify(false));
    }
  }

  navigate(url: string) {
    this.router.navigate([url]);
    this.closeMenu();
  }
}


